module.exports = __webpack_public_path__ + "img/stu1.e6fceb3d.jpeg";